import { useEffect, useState } from 'react';

import { getUserProfile } from '../services/userService';
import type { UserProfile } from '../types/models';

export type MiniProfile = Pick<UserProfile, 'displayName' | 'badges'>;

/**
 * Verilen uid listesi için hafif profil önbelleği (isim + rozetler).
 */
export function useMiniProfiles(userIds: string[]): Record<string, MiniProfile> {
  const [map, setMap] = useState<Record<string, MiniProfile>>({});
  const stableKey = [...new Set(userIds.filter(Boolean))].sort().join(',');

  useEffect(() => {
    const unique = stableKey ? stableKey.split(',') : [];
    if (unique.length === 0) {
      setMap({});
      return;
    }
    let cancelled = false;
    void (async () => {
      const entries = await Promise.all(
        unique.map(async uid => {
          try {
            const p = await getUserProfile(uid);
            const mini: MiniProfile = {
              displayName: p?.displayName?.trim() || 'Annedaş',
              badges: p?.badges,
            };
            return [uid, mini] as const;
          } catch {
            const mini: MiniProfile = { displayName: 'Annedaş', badges: undefined };
            return [uid, mini] as const;
          }
        }),
      );
      if (cancelled) {
        return;
      }
      setMap(Object.fromEntries(entries));
    })();
    return () => {
      cancelled = true;
    };
  }, [stableKey]);

  return map;
}
